/* tslint:disable */
/* eslint-disable */
/**
 * Coworker IAM API
 * Provides coworker identity and access management functionalities
 *
 * The version of the OpenAPI document: 1.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AuthorizeResponseDto
 */
export interface AuthorizeResponseDto {
    /**
     * Whether the coworker is authorized for the permission
     * @type {boolean}
     * @memberof AuthorizeResponseDto
     */
    authorized: boolean;
}

/**
 * Check if a given object implements the AuthorizeResponseDto interface.
 */
export function instanceOfAuthorizeResponseDto(value: object): boolean {
    if (!('authorized' in value)) return false;
    return true;
}

export function AuthorizeResponseDtoFromJSON(json: any): AuthorizeResponseDto {
    return AuthorizeResponseDtoFromJSONTyped(json, false);
}

export function AuthorizeResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuthorizeResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'authorized': json['authorized'],
    };
}

export function AuthorizeResponseDtoToJSON(value?: AuthorizeResponseDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'authorized': value['authorized'],
    };
}

